import store from 'Redux/store';

export const RESET_PASSWORD_RESET = 'frontend/password-reset/RESET_PASSWORD_RESET';
export const NEW_STATE_PASSWORD_RESET = 'frontend/password-reset/NEW_STATE_PASSWORD_RESET';

export function newState(statePassed) {
  store.dispatch({ type: NEW_STATE_PASSWORD_RESET, payload: statePassed });
}
